import {onDomReady} from "../lib/on_dom_ready";

onDomReady(() => {
  const roleSelect = document.querySelector("#system_admin_user_menu select");

  if (!roleSelect) {
    return;
  }

  roleSelect.addEventListener("change", () => {
    const form = document.querySelector("#system_admin_user_menu form");

    if (form) {
      form.submit();
    }
  });
});
